import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import ActionMenu, { ActionMenuTab } from './ActionMenu';
import { IUEvent } from '../../lib/event';

import { DeviceQueries, VerticalFullContainer } from 'Common/src/components/styled';

interface Props {
  event?: IUEvent;
  isCreate?: boolean;
  scrollToTop: () => void;
  openTab?: ActionMenuTab;
  setOpenTab: (tab: ActionMenuTab) => void;
}

const PageContentWithActionMenu = ({
                                     event,
                                     children,
                                     isCreate,
                                     scrollToTop,
                                     openTab,
                                     setOpenTab
                                   }: PropsWithChildren<Props>) => {
  return <PageLayout>
    {event && <ActionMenu
        event={event} isCreate={isCreate} scrollToTop={scrollToTop} openTab={openTab} setOpenTab={setOpenTab}
    />}
    <VerticalFullContainer>
      {children}
    </VerticalFullContainer>
  </PageLayout>;
};

const PageLayout = styled(VerticalFullContainer)`
  width: 100%;
  flex-direction: row;

  @media (${DeviceQueries.mobile}) {
    flex-direction: column-reverse;
  }
`;

export default PageContentWithActionMenu;
